<template>
    <div class="row">
        <div class="col-12">
            <ibox :title="title_edit">
                <template slot="content" slot-scope="{ setLoading }">
                    <Form slot="content" @loading="setLoading" />
                </template>
            </ibox>
            <!-- <ibox :title="title_dismiss">
                <template slot="content" slot-scope="{ setLoading }">
                    <base-dismiss slot="content" @loading="setLoading" />
                </template>
            </ibox> -->
        </div>
    </div>
</template>

<script>
    import Ibox from '@/components/Ibox'
    import Form from '@/components/VNFR/Shops/Form'
    // import BaseDismiss from '@/components/Comparison/Dismiss'

    export default {
        name: 'BaseAdd',
        data() {
            return {
            title_edit: 'Edycja sklepu',
            title_dismiss: 'Usuń bazę'
            }
        },
        components: {
            Ibox,
            Form
            // BaseDismiss
        }
    }
</script>
